import React from "react";
import LocalLogicClient from "@local-logic/client";
import { LocalLogicProvider } from "@local-logic/elements-react";
import { useStateManagerContext } from "../stateManager";

interface ElementsProviderProps {
  children: React.ReactNode;
}

const ElementsProvider: React.FC<ElementsProviderProps> = ({ children }) => {
  const { sdkState } = useStateManagerContext();

  if (!sdkState?.apiKey) {
    throw Error("A valid apiKey must be provided.");
  }

  const client = LocalLogicClient(sdkState.apiKey, {
    locale: sdkState?.globalOptions?.locale,
  });

  return (
    <LocalLogicProvider
      client={client}
      options={{ appearance: sdkState?.globalOptions?.appearance }}
    >
      {children}
    </LocalLogicProvider>
  );
};

export default ElementsProvider;
